<template>
    <div v-if="task.output">
        Saída V2: {{ task.output.value }}
    </div>
</template>
<script>
    export default {
        props: {
            task: {
                type: Object
            }
        }
    }
</script>


// WEBPACK FOOTER //
// TestV2.vue?120c8f02